import { FILE_SIZE_URL } from 'components/flowBuilder/constants/apiRoutes';
import {
  IMAGE_MIME_TYPE_PREFIX,
  MMS_MAX_IMAGE_SIZE,
  RCS_CARD_MAX_IMAGE_SIZE,
  RCS_CAROUSEL_CARD_MAX_IMAGE_SIZE,
} from 'components/flowBuilder/constants/files';
import { RcsMessageCategories } from 'constants/rcs';
import { api } from 'controllers/network/apiClient';
import { RcsMessageCategory } from 'types/rcs';

interface ImageFileSizeResponse {
  // eslint-disable-next-line camelcase
  file_size: number;
}

const isImageFileSizeResponse = (
  response: unknown,
): response is ImageFileSizeResponse => {
  const responseValue = response as ImageFileSizeResponse;
  if (!responseValue || typeof responseValue !== 'object') return false;
  if (typeof responseValue.file_size !== 'number') return false;
  return true;
};

export const getImageFileSize = async (url: string): Promise<number> => {
  const response: unknown = await api.post(FILE_SIZE_URL, { s3_url: url });
  if (!isImageFileSizeResponse(response))
    throw new Error('Unexpected image file size response');
  return response.file_size;
};

export interface ValidateImageFileOptions {
  maxImageSize?: number;
  maxImageSizeErrorMessage?: string;
  rcsMessageCategory?: RcsMessageCategory;
  skipSizeValidation?: boolean;
}

export const validateImageFile = (
  file: File,
  options: ValidateImageFileOptions = {},
) => {
  if (!file.type.startsWith(IMAGE_MIME_TYPE_PREFIX))
    throw new Error('File type is not allowed');

  const {
    maxImageSize,
    maxImageSizeErrorMessage,
    rcsMessageCategory,
    skipSizeValidation,
  } = options;

  if (skipSizeValidation) return;

  const defaultMaxImageSize =
    rcsMessageCategory === RcsMessageCategories.CAROUSEL
      ? RCS_CAROUSEL_CARD_MAX_IMAGE_SIZE
      : rcsMessageCategory === RcsMessageCategories.CARD
      ? RCS_CARD_MAX_IMAGE_SIZE
      : MMS_MAX_IMAGE_SIZE;

  const finalMaxImageSize = maxImageSize ?? defaultMaxImageSize.value;

  const finalMaxImageSizeErrorMessage =
    maxImageSizeErrorMessage ?? defaultMaxImageSize.errorMessage;

  if (file.size > finalMaxImageSize)
    throw new Error(finalMaxImageSizeErrorMessage);
};
